import { FC, useEffect, useState } from 'react';
import { MenuItem, Grid } from '@mui/material';
import { IDropdownResponse } from '../../../models';
import { getJobStatuses, getJobTypes } from '../../../fetch';
import { FiltersButtons, FiltersLayout, SMBSelect } from '../../../components';
import { NeighborhoodAutocompleteDropdown } from '../../../components/dropdowns/neighborhood-autocomplete';

interface IJobFilters {
  isLoading: boolean;
  applyFilters: (clearFilters?: boolean) => void;
  setPage: (val: number) => void;
  setHasAppliedFilters: (val: boolean) => void;
  hasAppliedFilters?: boolean;
  selectedNeighborhoodId: string;
  setSelectedNeighborhoodId: (val: any) => void;
  selectedStatus: string | null;
  setSelectedStatus: (val: string | null) => void;
  selectedType: string | null;
  setSelectedType: (val: string | null) => void;
}

export const JobFilters: FC<IJobFilters> = ({
  hasAppliedFilters,
  setHasAppliedFilters,
  isLoading,
  applyFilters,
  selectedNeighborhoodId,
  setSelectedNeighborhoodId,
  selectedStatus,
  setSelectedStatus,
  selectedType,
  setSelectedType
}) => {
  const [isLoadingStatuses, setIsLoadingStatuses] = useState(false);
  const [statuses, setStatuses] = useState<IDropdownResponse[]>([]);
  const [isLoadingTypes, setIsLoadingTypes] = useState(false);
  const [types, setTypes] = useState<IDropdownResponse[]>([]);

  const fetchStatuses = async () => {
    setIsLoadingStatuses(true);
    try {
      const res = await getJobStatuses();
      setStatuses(res);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingStatuses(false);
    }
  };

  const fetchTypes = async () => {
    setIsLoadingTypes(true);
    try {
      const res = await getJobTypes();
      setTypes(res);
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoadingTypes(false);
    }
  };

  useEffect(() => {
    fetchStatuses();
    fetchTypes();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <FiltersLayout>
      <Grid item xs={12} md={4} lg={3}>
        <NeighborhoodAutocompleteDropdown
          disableClearable={false}
          value={selectedNeighborhoodId}
          handleChange={value => setSelectedNeighborhoodId(value)}
        />
      </Grid>
      <Grid item xs={12} md={4} lg={3}>
        <SMBSelect
          label={isLoadingStatuses ? 'Loading...' : 'Status'}
          disabled={isLoading || isLoadingStatuses}
          value={selectedStatus ? selectedStatus : ''}
          onChange={e => {
            setSelectedStatus(e.target.value);
          }}
          handleClear={() => setSelectedStatus('')}
        >
          {statuses &&
            !isLoadingStatuses &&
            statuses.map((status, index) => {
              return (
                <MenuItem key={`${status.value}-${index}`} value={status.value}>
                  {status.description}
                </MenuItem>
              );
            })}
        </SMBSelect>
      </Grid>
      <Grid item xs={12} md={4} lg={3}>
        <SMBSelect
          label={isLoadingTypes ? 'Loading...' : 'Type'}
          disabled={isLoading || isLoadingTypes}
          value={selectedType ? selectedType : ''}
          onChange={e => {
            setSelectedType(e.target.value);
          }}
          handleClear={() => setSelectedType('')}
        >
          {types &&
            !isLoadingTypes &&
            types.map((type, index) => {
              return (
                <MenuItem key={`${type.value}-${index}`} value={type.value}>
                  {type.description}
                </MenuItem>
              );
            })}
        </SMBSelect>
      </Grid>
      <Grid item xs={12} lg={3}>
        <FiltersButtons
          hasAppliedFilters={hasAppliedFilters}
          isDisabled={isLoading}
          handleApplyFilters={() => {
            setHasAppliedFilters(true);
            applyFilters();
          }}
          handleResetFilters={() => {
            setHasAppliedFilters(false);
            setSelectedNeighborhoodId(null);
            setSelectedStatus(null);
            setSelectedType(null);
            applyFilters(true);
          }}
        />
      </Grid>
    </FiltersLayout>
  );
};
